import { createFileRoute } from '@tanstack/react-router';

import { HarvestProofListPage } from '@harvest-proof/feature';

export const Route = createFileRoute('/_app/harvest-proof')({
  component: HarvestProofListPage,
});
